import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as UserSvg } from './assets/user.svg';

const UserIcon = React.forwardRef((args, ref) => <SvgIcon component={UserSvg} ref={ref} {...args} />);

export default UserIcon;
